import { usageId } from "../../constants/usageid.js";
import { RoleSchemaIds, RoleTags } from "../../schemas/role.const.js";
export const dictionary = {
    schema: {
        // [RoleSchemaIds_deprecated.ROLE]: {
        //   title: 'Role',
        //   description: 'A role that can be assigned to a human agent.',
        // },
        // [RoleSchemaIds_deprecated.ROLE_LIST]: {
        //   title: 'List of roles',
        //   description: 'A list of roles.',
        // },
        // [RoleSchemaIds_deprecated.DOMAIN_ROLE_FILTER]: {
        //   title: 'Role filter',
        //   description: 'Collection of optional values where to filter on.',
        // },
        // [RoleSchemaIds_deprecated.CREATE_ROLE]: {
        //   title: 'Role name and title',
        //   description: 'The name and title for a new role in a domain.',
        // },
        // [RoleSchemaIds_deprecated.CREATE_DOMAIN_ROLE]: {
        //   title: 'Role name, tile and domain',
        //   description: 'The name, title and domain for a new role.',
        // },
        // [RoleSchemaIds_deprecated.UPDATE_ROLE]: {
        //   title: 'Role properties to update',
        //   description: 'Collection of optional properties to update on a role.',
        // },
        [usageId(RoleSchemaIds.ROLE, RoleTags.SYSTEM)]: {
            title: 'System Role',
            description: 'An immutable role.',
        },
        [usageId(RoleSchemaIds.ROLE, RoleTags.DOMAIN)]: {
            title: 'Role',
            description: 'An atlas specific role.',
        },
    },
};
